import React from 'react';

import { Icon } from '../icons';

export const DownloadIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M26.0938 29.125H6.40625C5.62695 29.125 5 28.498 5 27.7188V26.3125C5 25.5332 5.62695 24.9062 6.40625 24.9062H26.0938C26.873 24.9062 27.5 25.5332 27.5 26.3125V27.7188C27.5 28.498 26.873 29.125 26.0938 29.125ZM22.2031 12.6895L18.3594 16.5332V4.28125C18.3594 3.50195 17.7324 2.875 16.9531 2.875H15.5469C14.7676 2.875 14.1406 3.50195 14.1406 4.28125V16.5332L10.2969 12.6895C9.74609 12.1387 8.85547 12.1387 8.31055 12.6895L7.31445 13.6855C6.76367 14.2363 6.76367 15.127 7.31445 15.6719L15.2539 23.6113C15.8047 24.1621 16.6953 24.1621 17.2402 23.6113L25.1797 15.6719C25.7305 15.1211 25.7305 14.2305 25.1797 13.6855L24.1836 12.6895C23.6387 12.1387 22.748 12.1387 22.2031 12.6895Z" />
    </svg>
  );
};
